/// <reference path="./global.d.ts" />
/*!
 * @preserve
 * IPv6Test.js
 * JS-Bestandteil des IPv6-Test (BrowserInfoCollector Contao Modul / dein-ip-check.de)
 *
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import {detectIP, INetProtocol} from "./tests/ip";
import {guiFunctions} from "./tests/guifunctions";

// Polyfills hinzuladen 
require('es6-promise').polyfill();
require('string.prototype.repeat');

window.onload = () => {
    detectIP.detectPrimaryProtocol( (isIPv6 === "1") );
    detectIP.updateIP( INetProtocol.IPv4, (isIPv6 === "1" ? INetProtocol.IPv6 : INetProtocol.IPv4) );
    guiFunctions.initClipboard();
    guiFunctions.initWhois(INetProtocol.IPv6, "#ipv6adress", "#ipv6whois");
    guiFunctions.initWhois(INetProtocol.IPv4, "#ipv4adress", "#ipv4whois");
};

